module.exports = __webpack_public_path__ + "static/media/desktop_separator_03.eca7320a.webp";